// import React from "react";
// import PropTypes from "prop-types";

// const MonthSelect = ({
//   selectedMonth,
//   selectedMonthName,
//   months,
//   onChange,
//   className = "col-sm-3",
// }) => (
//   <div className={className}>
//     <select className="form-select" name="selectedMonth" onChange={onChange}>
//       <option defaultValue disabled={!!(selectedMonth || selectedMonthName)}>
//         Select Month
//       </option>
//       <option value="AllMonths">All Months</option>
//       {months.map((month, index) => (
//         <option key={index} value={JSON.stringify(month.tran_date)}>
//           {month.name}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// MonthSelect.propTypes = {
//   selectedMonth: PropTypes.string,
//   selectedMonthName: PropTypes.string,
//   months: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string.isRequired,
//       tran_date: PropTypes.shape({
//         $gte: PropTypes.string.isRequired,
//         $lte: PropTypes.string.isRequired,
//       }).isRequired,
//     })
//   ).isRequired,
//   onChange: PropTypes.func.isRequired,
//   className: PropTypes.string,
// };

// export default MonthSelect;
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const MonthSelect = ({
  selectedMonth,
  selectedMonthName,
  months,
  onChange,
  className = "col-sm-6 col-lg-3",
  label = "Month",
  placeholder = "Select Month",
  disabled = false,
  error,
  helperText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value, monthName) => {
    // Create synthetic event to match your existing onChange handler
    const syntheticEvent = {
      target: {
        name: "selectedMonth",
        value: value,
      },
    };

    onChange(syntheticEvent);
    setIsOpen(false);
    setSearchTerm("");
  };

  const filteredMonths = months.filter((month) =>
    month.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const displayValue = selectedMonthName || placeholder;

  return (
    <div className={className}>
      <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
        {label && (
          <label
            style={{
              display: "block",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: error ? "#ef4444" : "#374151",
              marginBottom: "6px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {label}
          </label>
        )}

        {/* Custom Select Button */}
        <button
          type="button"
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
          style={{
            width: "100%",
            height: "38px",
            padding: "0 12px",
            border: error
              ? "1px solid #ef4444"
              : isOpen
                ? "1px solid #1F4D2C"
                : "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "0.9rem",
            fontFamily: "Inter, sans-serif",
            backgroundColor: disabled ? "#f9fafb" : "#ffffff",
            cursor: disabled ? "not-allowed" : "pointer",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "all 0.2s ease",
            color: selectedMonthName ? "#374151" : "#9ca3af",
            boxShadow: isOpen
              ? error
                ? "0 0 0 3px rgba(239, 68, 68, 0.1)"
                : "0 0 0 3px rgba(31, 77, 44, 0.1)"
              : "none",
          }}
        >
          <span>{displayValue}</span>
          <i
            className={`bi bi-calendar3`}
            style={{
              fontSize: "1rem",
              color: disabled ? "#d1d5db" : "#6b7280",
            }}
          ></i>
        </button>

        {/* Custom Dropdown */}
        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              backgroundColor: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
              zIndex: 1000,
              maxHeight: "300px",
              overflow: "hidden",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {/* Search Input */}
            {/* <div
              style={{
                padding: "8px 12px",
                borderBottom: "1px solid #f3f4f6",
                position: "sticky",
                top: 0,
                backgroundColor: "#ffffff",
                zIndex: 1,
              }}
            >
              <input
                type="text"
                placeholder="Search month..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  fontFamily: "Inter, sans-serif",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#1F4D2C";
                  e.target.style.boxShadow = "0 0 0 2px rgba(31, 77, 44, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div> */}

            {/* Options List */}
            <div
              style={{
                maxHeight: "240px",
                overflowY: "auto",
                padding: "4px",
              }}
            >
              {/* All Months Option */}
              {/* <div
                onClick={() => handleSelect("AllMonths", "All Months")}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  borderRadius: "6px",
                  fontSize: "0.9rem",
                  color: selectedMonth === "AllMonths" ? "#ffffff" : "#374151",
                  backgroundColor:
                    selectedMonth === "AllMonths" ? "#1F4D2C" : "transparent",
                  fontWeight: selectedMonth === "AllMonths" ? 600 : 400,
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  if (selectedMonth !== "AllMonths") {
                    e.currentTarget.style.backgroundColor = "#f3f4f6";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedMonth !== "AllMonths") {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                All Months
              </div> */}

              {/* Month Options */}
              {filteredMonths.length > 0 ? (
                filteredMonths.map((month, index) => {
                  const value = JSON.stringify(month.tran_date);
                  const isSelected = selectedMonth === value;

                  return (
                    <div
                      key={index}
                      onClick={() => handleSelect(value, month.name)}
                      style={{
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderRadius: "6px",
                        fontSize: "0.9rem",
                        color: isSelected ? "#ffffff" : "#374151",
                        backgroundColor: isSelected ? "#1F4D2C" : "transparent",
                        fontWeight: isSelected ? 600 : 400,
                        transition: "all 0.15s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = "#f3f4f6";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {month.name}
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    padding: "20px 12px",
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "0.85rem",
                  }}
                >
                  <i
                    className="bi bi-search"
                    style={{
                      fontSize: "1.5rem",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  ></i>
                  <p className="mb-0">No months found</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Helper Text */}
        {helperText && !error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#6b7280",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-info-circle me-1"></i>
            {helperText}
          </small>
        )}

        {/* Error Message */}
        {error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#ef4444",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-exclamation-circle me-1"></i>
            {error}
          </small>
        )}
      </div>
    </div>
  );
};

MonthSelect.propTypes = {
  selectedMonth: PropTypes.string,
  selectedMonthName: PropTypes.string,
  months: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      tran_date: PropTypes.shape({
        $gte: PropTypes.string.isRequired,
        $lte: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
};

export default MonthSelect;
